import './index.css';

import { GlobalErrorBoundary } from '@Common/GlobalErrorBoundary';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import { store } from './store';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </Provider>,
);
